import MyChecks from '../components/Check/MyChecks'

let routes = {
    path: '/myChecks',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/myChecks',
            name: 'Meus pontos',
            component: MyChecks
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/myChecks.js